import AmbassadorShell, { card, eyebrow, h1Style, muted, primaryBtn, Reveal } from "./_AmbassadorShell";
import { Link } from "react-router-dom";

// Admin tooling has moved to the shared ElectricSheep operator console.
// This page degrades to a read-only cutover notice so HireEva admins know
// where to go. The old direct-table writes are no longer wired here.
export default function AmbassadorAdmin() {
  return (
    <AmbassadorShell>
      <Reveal>
        <p style={eyebrow}>Admin · cutover in progress</p>
        <h1 style={h1Style}>Admin tools moved.</h1>
        <div style={{ ...card, marginTop: 16 }}>
          <p style={{ color: muted, fontSize: 16, margin: 0 }}>
            Ambassador moderation, payouts approval, and manual referral entry
            now live in the shared ElectricSheep operator console. Reach out at{" "}
            <strong>admin@electricsheephq.com</strong> if you need access.
          </p>
          <div style={{ marginTop: 16 }}>
            <Link to="/ambassadors/dashboard" style={primaryBtn}>Back to dashboard →</Link>
          </div>
        </div>
      </Reveal>
    </AmbassadorShell>
  );
}